import React from 'react';
import Button from '@mui/material/Button';

function Subestacion2(props) {
    
    return(
        <div id='contenedor-boton-anydesk-subestacion'>
            <Button id='boton-anydesk-subestacion' variant="outlined" size="medium" href="anydesk:362080563">Pulsa aquí para conectarte a la SET PORTACOELI</Button>
        </div>
    )
}

export default Subestacion2